import { render } from "./AdminOrderItemList.vue?vue&type=template&id=222f6ea8&scoped=true&ts=true&lang=true"
import script from "./AdminOrderItemList.vue?vue&type=script&lang=ts"
export * from "./AdminOrderItemList.vue?vue&type=script&lang=ts"

import "./AdminOrderItemList.vue?vue&type=style&index=0&id=222f6ea8&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222f6ea8"]])

export default __exports__